import client, { API } from "./client";

export const fetchReport = async (params) => (await client.get("/reports/attendance", { params })).data;

export const downloadReport = async (format, lang, params) => {
  const res = await client.get("/reports/export", {
    params: { ...params, format, lang },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `attendance-report.${format}`;
  a.click();
  URL.revokeObjectURL(url);
};

export const listKeys = async () => (await client.get("/api-keys")).data;
export const createKey = async (body) => (await client.post("/api-keys", body)).data;
export const revokeKey = (id) => client.delete(`/api-keys/${id}`);
export const listWebhooks = async () => (await client.get("/webhooks")).data;
export const listEvents = async () => (await client.get("/webhook-events")).data;
export const createWebhook = async (body) => (await client.post("/webhooks", body)).data;
export const deleteWebhook = (id) => client.delete(`/webhooks/${id}`);
export const listDeliveries = async () => (await client.get("/webhook-deliveries")).data;
export const fetchAbsenceReport = async (params) => (await client.get("/reports/absences", { params })).data;

export const exportAbsences = async (format, lang, filters) => {
  const res = await client.get("/reports/absences/export", {
    params: { format, lang, ...filters },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `absences.${format}`;
  link.click();
  window.URL.revokeObjectURL(url);
};

export const fetchEntityReport = async (params) =>
  (await client.get("/reports/entities", { params })).data;
export const exportEntities = async (format, lang, filters = {}) => {
  const res = await client.get("/reports/entities/export", {
    params: { format, lang, from_date: filters.from_date, to_date: filters.to_date },
    responseType: "blob",
  });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = `entities-report.${format === "pdf" ? "pdf" : "xlsx"}`;
  link.click();
  URL.revokeObjectURL(url);
};
export const docsUrl = `${API}/docs`;

